import { BehaviorSubject } from 'rxjs';
export const getCalculationDetailsStore = () => {
    const getInitialState = () => ({
        isLoading: true,
        id: null,
        status: null,
        clientId: null,
        clientName: null,
        companyName: null,
        companyId: null,
        calculationNameId: null,
        quarter: null,
        year: null,
        isRectification: false,
        currentStepNumber: 0,
        latestActiveStep: 0,
        companyActiveRoles: [],
        companyHasActiveRectification: false,
        reopeningInvolvedRoles: [],
        statementStatus: null,
        activeUserEmail: null,
        steps: []
    });
    const calculationSubject = new BehaviorSubject(getInitialState());
    const setCalculationDetails = (calculationDetails) => {
        const latestActiveStep = calculationDetails.latestActiveStep - 1;
        calculationSubject.next({
            ...calculationDetails,
            latestActiveStep: latestActiveStep,
            isLoading: false,
            currentStepNumber: latestActiveStep
        });
    };
    const getCalculationDetails = () => calculationSubject.getValue();
    const updateStepNumber = (newStepNumber) => calculationSubject.next({
        ...calculationSubject.getValue(),
        currentStepNumber: newStepNumber
    });
    const increaseStepNumber = () => calculationSubject.next({
        ...calculationSubject.getValue(),
        currentStepNumber: getCurrentStepNumber() + 1
    });
    const updateLatestActiveStep = (stepNumber) => calculationSubject.next({
        ...calculationSubject.getValue(),
        latestActiveStep: stepNumber - 1
    });
    const setStatus = (status) => calculationSubject.next({
        ...calculationSubject.getValue(),
        status
    });
    const getCurrentStepNumber = () => calculationSubject.getValue().currentStepNumber;
    const getCalculationId = () => calculationSubject.getValue().id;
    const getClientId = () => calculationSubject.getValue().clientId;
    const subscribe = (callback) => calculationSubject.subscribe(callback);
    const reset = () => calculationSubject.next(getInitialState());
    const setIsLoading = (value) => {
        calculationSubject.next({
            ...calculationSubject.getValue(),
            isLoading: value
        });
    };
    return {
        subscribe,
        getInitialState,
        reset,
        setCalculationDetails,
        updateStepNumber,
        increaseStepNumber,
        getCurrentStepNumber,
        getCalculationId,
        getClientId,
        getCalculationDetails,
        updateLatestActiveStep,
        setIsLoading,
        setStatus
    };
};
